import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--navy-950)] text-[var(--bone)] overflow-hidden"
    >
      <div className="grain absolute inset-0"></div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="/logo-mark-192.png"
                alt="Freedom In Me"
                className="w-11 h-11 object-contain bg-[var(--bone)] p-1 rounded-sm"
                width={44}
                height={44}
              />
              <div>
                <div className="font-display text-[20px] tracking-tight text-[var(--bone)]">Freedom In Me, LLC</div>
                <div className="text-[10px] tracking-[0.32em] uppercase text-[var(--navy-100)]/65">North Carolina · United States</div>
              </div>
            </div>
            <p className="mt-7 text-[15px] leading-relaxed text-[var(--navy-100)]/80 max-w-md">
              Organizational alignment and AI readiness for the modern workforce. Built on{" "}
              <span className="font-semibold" style={{ color: "var(--gold-soft)" }}>50+ years</span> of combined leadership
              across public, private, and social sectors.
            </p>
            <Link
              to="/about"
              data-testid="footer-about-link"
              className="inline-flex items-center gap-2 mt-7 text-[12px] tracking-[0.28em] uppercase font-semibold transition-colors"
              style={{ color: "var(--gold-soft)" }}
            >
              Meet the leadership <ArrowUpRight size={14} />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow-light">Navigate</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li>
                <a
                  href="https://www.itsthefreedominme.com"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-[var(--gold-soft)]"
                >
                  Main Site
                </a>
              </li>
              <li><Link to="/align" className="hover:text-[var(--gold-soft)]">A.L.I.G.N.™ Framework</Link></li>
              <li><Link to="/process" className="hover:text-[var(--gold-soft)]">How We Engage</Link></li>
              <li><Link to="/assessment" className="hover:text-[var(--gold-soft)]">Readiness Assessment</Link></li>
              <li><Link to="/about" className="hover:text-[var(--gold-soft)]">About Donja</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="eyebrow-light">Begin the Conversation</div>
            <h4 className="font-display text-[22px] mt-4 text-[var(--bone)]">
              A 30-minute call. No prep required.
            </h4>
            <Link
              to="/contact"
              data-testid="footer-book-call-cta"
              className="btn-gold inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full text-[12px] tracking-[0.22em] uppercase font-semibold"
            >
              Book a Strategy Call <ArrowUpRight size={14} />
            </Link>
            <a
              href="mailto:info@itsthefreedominme.com"
              data-testid="footer-email-link"
              className="flex items-center gap-2 mt-6 text-[14px] text-[var(--navy-100)]/80 hover:text-[var(--gold-soft)]"
            >
              <Mail size={16} /> info@itsthefreedominme.com
            </a>
          </div>
        </div>

        <div className="hairline-light mt-16"></div>
        <div className="mt-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4 text-[12px] text-[var(--navy-100)]/60">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <span>© {new Date().getFullYear()} Freedom In Me, LLC. All rights reserved.</span>
            <span className="hidden md:inline text-[var(--navy-100)]/30">·</span>
            <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[var(--gold-soft)] underline-offset-2 hover:underline">Privacy</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="hover:text-[var(--gold-soft)] underline-offset-2 hover:underline">Terms</Link>
            <Link to="/security" data-testid="footer-link-security" className="hover:text-[var(--gold-soft)] underline-offset-2 hover:underline">Security</Link>
            <Link to="/blog" data-testid="footer-link-blog" className="hover:text-[var(--gold-soft)] underline-offset-2 hover:underline">Blog</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="hover:text-[var(--gold-soft)] underline-offset-2 hover:underline">Contact</Link>
            <a
              href="https://pay.itsthefreedominme.com"
              data-testid="footer-link-pay-invoice"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[var(--gold-soft)] underline-offset-2 hover:underline"
            >
              Pay Invoice
            </a>
          </div>
          <div className="tracking-[0.22em] uppercase">
            A.L.I.G.N.™ is a signature framework of Freedom In Me, LLC.
          </div>
        </div>
      </div>
    </footer>
  );
}
